import { render, staticRenderFns } from "./PatRePassPage.vue?vue&type=template&id=0c54581a"
import script from "./PatRePassPage.vue?vue&type=script&lang=js"
export * from "./PatRePassPage.vue?vue&type=script&lang=js"
import style0 from "./PatRePassPage.vue?vue&type=style&index=0&id=0c54581a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports